import { axiosGet } from '../ServiceBase.js';

export const findTransitorias = async () => {
  return axiosGet('/v1/derivaciones/transitorias');
};
